import { SystemProps } from '@chakra-ui/react'
import { colors } from './colors'

export const rounded = {
  container: 6,
  input: '0.375rem'
}

export const padding = {
  container: {
    px: {
      base: 0,
      md: 12
    },
    py: {
      base: 4,
      md: 12
    }
  },
  button: {
    px: {
      base: 4,
      md: 6
    },
    py: {
      base: 4,
      md: 6
    }
  }
}

export const inputWidth = {
  base: '260px',
  md: '260px'
}

export const inputHeight = {
  base: '34px',
  md: '34px'
}

export const inputContainerHeight = {
  base: 70
}

export const fontSize = {
  input: '0.85rem',
  label: '0.8rem',
  title: {
    base: '1rem',
    md: '1.3rem'
  }
}

export const fontWeight = {
  label: 500
}

export const inputPadding = {
  base: '1rem'
}

export const field = {
  inputWidth: inputWidth,
  inputHeight: inputHeight,
  fontSize: fontSize,
  fontWeight: fontWeight,
  inputPadding: inputPadding,
  inputContainerHeight,
  labelPadding: {
    base: '0 12px 4px 0'
  }
}

export const border = {
  width: '2.5px',
  color: colors.tertiary[1],
  containerColor: colors.neutralDark
}

export const formatCurrencyAmount = (number?: number): string => {
  if (!number) return '$0'
  // changes "1000000" into 1,000,000" or "12233.562" to "$12,233.56"
  return `$${number.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}`
}

export const containerCardStyles: Partial<SystemProps> = {
  boxSize: 'full',
  bg: '#F9FAFB',
  shadow: 'sm',
  padding: '1rem',
  rounded: 'md',
  borderColor: colors.border,
  borderWidth: 1,
  _focus: {
    borderColor: colors.tertiary[1],
    outlineColor: colors.tertiary[1],
    shadow: 'none'
  }
}

// Table styles
export const tableStyles = {
  // Font sizes for different table elements
  fontSize: {
    badge: { base: '0.55rem', lg: '0.65rem' },
    tag: { base: '0.6rem', lg: '0.75rem' },
    text: { base: '0.65rem', lg: '0.7rem' },
    button: { base: '0.7rem', lg: '0.8rem' },
    icon: { base: '0.8rem', lg: '0.9rem' }
  },
  // Component sizes
  size: {
    badge: 'sm' as const,
    tag: 'sm' as const,
    button: 'sm' as const,
    spinner: 'xs' as const
  },
  // Font weights
  fontWeight: {
    normal: 600,
    bold: 700
  },
  // Spacing
  gap: {
    small: '.3rem',
    medium: '1rem'
  },
  // Padding
  padding: {
    button: '0.3rem',
    buttonWithText: '0.3rem 0.5rem',
    iconOnlyButton: '0.3rem 0.6rem'
  }
}

export const buttonStyles = {
  size: 'sm' as const,
  gap: 2,
  fontSize: {
    base: '0.875rem'
  },
  fontWeight: 600,
  px: {
    base: 3,
    md: 4
  },
  py: {
    base: 2
  }
}

export const modalStyles = {
  modal: {
    isCentered: true,
    scrollBehavior: 'inside' as const,
    size: {
      base: 'full',
      md: '4xl',
      xl: '5xl'
    }
  },
  content: {
    maxH: '90vh',
    maxW: {
      base: '100%',
      md: '90%',
      xl: '80%'
    }
  },
  body: {
    maxH: 'calc(90vh - 120px)',
    overflowY: 'auto' as const,
    pb: 6
  }
}
